module.exports = __webpack_public_path__ + "img/bg_l_2_highlight.9d1c4130.png";